<template>
  <SPASearchbar v-model="localSearchString" @keydown.enter.stop="handleSearch" @clickSearch="handleSearch" placeholder="Search..." />
</template>

<script>
import { storeToRefs } from 'pinia';
import { ref } from 'vue';
import SPASearchbar from '../../../components/SPASearchbar.vue';
import { checkBlankSpace } from '../../../helpers/inputValidator';
import { useProjectTaggingStore } from '../../../stores/projectTagging';

export default {
  components: {
    SPASearchbar,
  },
  setup() {
    const projectTagging = useProjectTaggingStore();
    const { searchFilter, searchString, projectsPagination, localSelectedStatusFilter, selectedStatusFilter } = storeToRefs(projectTagging);
    const localSearchString = ref('');

    const handleSearch = async () => {
      searchString.value = localSearchString.value;
      selectedStatusFilter.value = localSelectedStatusFilter.value;
      const params = {
        SearchString: searchString.value,
        FilterBy: searchFilter.value,
        RowsPerPage: projectsPagination.value.itemsPerPage,
        StatusIds: selectedStatusFilter.value,
      };
      if (!checkBlankSpace(searchString.value)) {
        projectTagging.getProjects(params);
      } else {
        projectTagging.getProjects({
          RowsPerPage: projectsPagination.value.itemsPerPage,
          PageNumber: 1,
          StatusIds: selectedStatusFilter.value,
        });
      }
    };
    return {
      searchString,
      localSearchString,
      handleSearch,
    };
  },
};
</script>
